import { Suspense } from "react"
import { ArrowLeft } from "react-feather"
import { useNavigate, useParams } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { ReactErrorBoundary } from "@/components/ui/error-boundary"
import { SectionLoading } from "@/components/ui/loading"
import { TenantApplicantDetailContent } from "./components/TenantApplicantDetailContent"

export function TenantApplicantDetailPage() {
  const { applicantId } = useParams<{ applicantId: string }>()
  const navigate = useNavigate()

  if (!applicantId) {
    return <div>申請IDが指定されていません。</div>
  }

  return (
    <div className="space-y-6">
      {/* Header - 戻るボタン */}
      <div className="flex items-center gap-2.5">
        <Button
          variant="ghost"
          size="icon"
          className="w-7 h-7 shadow-sm"
          onClick={() => navigate("/tenant-applicants")}
        >
          <ArrowLeft size={14} />
        </Button>
        <h2 className="text-sm font-semibold text-slate-600">新規入居者申込一覧に戻る</h2>
      </div>

      {/* Title */}
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">新規入居者申込詳細</h1>
      </div>

      {/* Main Content */}
      <ReactErrorBoundary>
        <Suspense fallback={<SectionLoading />}>
          <TenantApplicantDetailContent applicantId={applicantId} />
        </Suspense>
      </ReactErrorBoundary>
    </div>
  )
}
